export const INTERCOM_ID = 'h8fjo8n2';

export function getUserData() {
  const store = window.$nuxt.store;

  if (store && store.getters.isLoggedIn) {
    const user = store.getters.user;
    return {
      name: user.first_name,
      email: user.email,
      created_at: user.created_at_unix,
      user_id: user.id.$oid,
      user_hash: user.hash,
      plan: user.plan,
    };
  }

  return {};
}

export async function intercomUpdate(data) {
  if (window.Intercom) {
    window.Intercom('update', data || getUserData());
  }
}

export async function intercomShutdown() {
  if (window.Intercom) {
    window.Intercom('shutdown');
  }
}
